import React, { useState } from 'react';
import PropTypes from 'prop-types';
import generateId from '$utils/generateId';
import { TextField as StyledTextField } from './TextField.styled';

const TextField = ({
  value,
  onChange,
  onBlur,
  defaultValue,
  label,
  ariaLabel,
  disabled,
  fullWidth,
  error,
}) => {
  // Setting an id correctly links the label with the input.
  // In state so we don't generate a new id on every render.
  const [domId] = useState(generateId());

  return (
    <StyledTextField
      autoComplete="off"
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      label={label}
      aria-label={ariaLabel || label}
      variant="outlined"
      margin="dense"
      fullWidth={fullWidth}
      color="secondary"
      error={error}
      id={domId}
    />
  );
};

TextField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  defaultValue: PropTypes.string,
  label: PropTypes.node,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
};

TextField.defaultProps = {
  value: undefined,
  onChange: undefined,
  onBlur: undefined,
  defaultValue: undefined,
  label: undefined,
  ariaLabel: undefined,
  disabled: false,
  fullWidth: false,
  error: undefined,
};

export default TextField;
